<template>
  <div class="jumbotron mb-0">
    <div class="container">
      <h1 class="d-none d-lg-block display-5">
        My RAINN Speakers Bureau Applications
      </h1>
      <h1 class="d-md-block d-lg-none display-6">
        My RAINN Speakers Bureau Applications
      </h1>
      <p class="lead">Thank you for coming forward to speak!</p>
      <hr />
      <button
        v-if="this.$store.getters['auth/isStaffer']"
        class="btn btn-secondary btn-sm mr-2"
        @click="() => this.$router.push('/search')"
      >
        View All Applications (RAINN Staffers Only)
      </button>
      <button class="btn btn-secondary btn-sm" @click="logout">Logout</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    logout: {
      type: Function,
      required: true,
      default: () => {}
    }
  }
};
</script>

<style></style>
